import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { ThemeProvider } from '@magicpatterns/cubed';
render(<ThemeProvider data-id="element-79">
    <App data-id="element-80" />
  </ThemeProvider>, document.getElementById('root'));